import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'

export const focusElement = (selector: string, asyncDelay?: number) => {
  try {
    const elementToFocus = document.querySelector(selector) as HTMLElement
    if (asyncDelay === undefined) elementToFocus?.focus()
    else setTimeout(() => elementToFocus?.focus(), asyncDelay)
  } catch (e) {
    trackWithoutThrow(e)
  }
}
